(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[715],{

/***/ 715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Quote": function() { return /* binding */ Quote; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6198);
/* harmony import */ var _Column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4992);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9748);
/* harmony import */ var _StorylinerImage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4090);
/* harmony import */ var _Quote_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6076);
/* harmony import */ var _Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Quote_module_css__WEBPACK_IMPORTED_MODULE_7__);
// import node_modules




// import types

// import component



// import styles

// Quote
var Quote = function(param) {
    var bgColor = param.bgColor, color = param.color, colorDark = param.colorDark, image = param.image, jobTitle = param.jobTitle, name = param.name, quote = param.quote, snippet = param.snippet, snippetDark = param.snippetDark;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Section__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
        bgColor: bgColor,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                cols: 3,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default()["image-canvas"]), snippet && (_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default())[snippet], snippetDark && (_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default())["".concat(snippetDark, "-dark")]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StorylinerImage__WEBPACK_IMPORTED_MODULE_6__["default"], {
                        imageId: image,
                        isRounded: false,
                        height: 512,
                        title: name,
                        width: 512
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                cols: 2,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default()["quote-container"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default()["quote-marks"]), color && (_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default())["is-".concat(color)], colorDark && (_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default())["is-".concat(colorDark, "-dark")])
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default()["quote-text"]), color && (_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default())["is-".concat(color)], colorDark && (_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default())["is-".concat(colorDark, "-dark")]),
                            dangerouslySetInnerHTML: {
                                __html: quote
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default()["quote-cite"]), color && (_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default())["is-".concat(color)], colorDark && (_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default())["is-".concat(colorDark, "-dark")]),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default()["quote-cite-name"]),
                                    children: name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_Quote_module_css__WEBPACK_IMPORTED_MODULE_7___default()["quote-cite-description"]),
                                    children: jobTitle
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
Quote.propTypes = {
    bgColor: prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_3__/* .SectionColorEnum */ .TJ)).isRequired,
    color: prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_3__/* .QuoteColorEnum */ .n7)).isRequired,
    colorDark: prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_3__/* .QuoteColorEnum */ .n7)).isRequired,
    image: prop_types__WEBPACK_IMPORTED_MODULE_8__.string.isRequired,
    jobTitle: prop_types__WEBPACK_IMPORTED_MODULE_8__.string.isRequired,
    name: prop_types__WEBPACK_IMPORTED_MODULE_8__.string.isRequired,
    quote: prop_types__WEBPACK_IMPORTED_MODULE_8__.string.isRequired,
    snippet: prop_types__WEBPACK_IMPORTED_MODULE_8__.string.isRequired,
    snippetDark: prop_types__WEBPACK_IMPORTED_MODULE_8__.string.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (Quote);


/***/ }),

/***/ 6076:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image-canvas":"storyliner-XwcJau","snippet-anakiwa-1":"storyliner-g5WZA4","snippet-tacao-1":"storyliner-f3Ubma","snippet-tawnyport-1":"storyliner-IyWQJw","snippet-yellow-1":"storyliner-Txxypu","snippet-anakiwa-1-dark":"storyliner-96Ufc8","snippet-tacao-1-dark":"storyliner-5xJxfK","snippet-tawnyport-1-dark":"storyliner-xT2thK","snippet-yellow-1-dark":"storyliner-palpLE","quote-marks":"storyliner-equZ10","is-white":"storyliner-0vnQZe","is-black":"storyliner-vX7xU4","is-white-dark":"storyliner-Q8916l","is-black-dark":"storyliner-B4ThDJ","quote-text":"storyliner-fz8CXw","quote-cite-name":"storyliner-8VbrNM","quote-cite":"storyliner-URLG3V","quote-container":"storyliner-MfVTKc"};

/***/ })

}]);